import { render, staticRenderFns } from "./proforma-ship-supplier.vue?vue&type=template&id=05a2002c&"
import script from "./proforma-ship-supplier.vue?vue&type=script&lang=js&"
export * from "./proforma-ship-supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports